/**
 * 프로모 페이지용 데이터 API
 *
 * 원본 zoku 서버에는 Partners, Blog, News에 대한 REST API가 없다.
 * 원본 서버의 SSR 페이지 HTML에서 데이터를 추출하는 프록시를 Vite에 추가했다.
 * /api/promo/* 엔드포인트를 통해 JSON 데이터를 가져온다.
 */
import axios from 'axios';

// Partners 데이터
export interface Partner {
  _id: string;
  game: string;
  company: string;
  genre?: string;
  platforms?: string[];
  mainPicture: Array<{ url: string }>;
  weight?: number;
  isPublished?: boolean;
}

// Blog 데이터
export interface BlogPost {
  slug: string;
  title: string;
  mainPicture: Array<{ url: string }>;
  introduction: string;
  content?: string;
  publicationDateAt: string;
  isPublished: boolean;
  category?: { name: string };
  author?: { profile?: { name?: string } };
}

// News 데이터
export interface NewsPost {
  _id: string;
  title: string;
  url: string;
  mainPicture: Array<{ url: string }>;
  language: string;
  publicationDate: string;
  isPublished: boolean;
}

export interface NewsLanguage {
  value: string;
  text: string;
}

const promoClient = axios.create({
  baseURL: '/api/promo',
  timeout: 30000,
});

export const promoApi = {
  async getPartners(): Promise<Partner[]> {
    const { data } = await promoClient.get<Partner[]>('/partners');
    return data;
  },

  async getBlogPosts(): Promise<BlogPost[]> {
    const { data } = await promoClient.get<BlogPost[]>('/blog');
    return data;
  },

  async getNewsPosts(language = 'all'): Promise<{ posts: NewsPost[]; languages: NewsLanguage[] }> {
    const { data } = await promoClient.get<{ posts: NewsPost[]; languages: NewsLanguage[] }>(`/news/${language}`);
    return data;
  },
};
